import React, { useState } from 'react';
import Box from '@cloudscape-design/components/box';
import ExpandableSection from '@cloudscape-design/components/expandable-section';
import StatusIndicator from '@cloudscape-design/components/status-indicator';

interface ResponseViewerProps {
  data: unknown;
  error?: string;
}

export const ResponseViewer: React.FC<ResponseViewerProps> = ({ data, error }) => {
  const [expanded, setExpanded] = useState(true);

  if (!data && !error) return null;

  return (
    <ExpandableSection
      expanded={expanded}
      onChange={({ detail }) => setExpanded(detail.expanded)}
      headerText={
        <StatusIndicator type={error ? 'error' : 'success'}>
          {error ? 'Error' : 'Success'}
        </StatusIndicator>
      }
    >
      <Box variant="code">
        <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
          {JSON.stringify(error || data, null, 2)}
        </pre>
      </Box>
    </ExpandableSection>
  );
};
